import { IAllPrivateRoutes } from "components/routes/app_routes";
import { user } from "config/roles";
import CourseMainPage from "domains/Course/containers/CourseMainPage";
import HistoryPage from "domains/History";
import TaskList from "domains/Tasks";
import { CourseScreen, Job, ParcelsTracking } from "../screens";

export const TaskRoutes: IAllPrivateRoutes[] = [
  { label: "Tasks", pathName: "/tracking/task", routeElement: TaskList, roles: user.roles },
  {
    label: "Job creation",
    pathName: "/parcels/creations",
    routeElement: Job,
    roles: user.roles,
  },
  {
    label: "Job creation",
    pathName: "/history",
    routeElement: HistoryPage,
    roles: user.roles,
  },
  {
    label: "Parcels",
    pathName: "/tracking/parcels",
    routeElement: ParcelsTracking,
    roles: user.roles,
  },
  {
    label: "Course",
    pathName: "/course/creation",
    routeElement: CourseScreen,
    roles: user.roles,
  },
];
